import styled from 'styled-components'
import { Calendar } from 'antd'

const AntCalendarStyled = styled(Calendar)`
  &&& {
    a {
      color: ${props => props.theme.colors.color1.bg};
    }
  }
`

export default AntCalendarStyled
